export const monitoring = {
  intervalId: null,
  observer: null,
};
